// extracted by css-extract-rspack-plugin
export default {"title":"_ab1c16cb"};